<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col lg="6">
        <div class="form-group form-actions float-right pb-2">
          <b-input-group>
            <b-form-input
              autocomplete="off"
              type="text"
              v-model="bulkAddPoints"
              v-mask="'######'"
              @focus="$event.target.select()"
            ></b-form-input>
            <b-button
              class="mr-2"
              type="submit"
              size="md"
              variant="primary"
              @click="bulkAdd"
            >
              <i class="fa fa-plus"></i>
              Add Points (To All)
            </b-button>
          </b-input-group>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="QuickAdd" slot-scope="data">
            <b-input-group>
              <b-form-input
                placeholder="Quick Add"
                id="QuickAddPoints"
                autocomplete="off"
                type="text"
                style="height: 25px; max-width: 50px;"
                v-model="data.item.QuickAddPoints"
                @focus="$event.target.select()"
              ></b-form-input>
              <i
                v-b-tooltip
                title="Quick Add"
                class="fa fa-lg fa-bolt ml-2 mt-1"
                v-on:click.stop="quickAdd(data.item)"
              ></i>
            </b-input-group>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRowsFiltered"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "RewardPointList",
  data: () => {
    return {
      fields: [
        {
          key: "UserName",
          label: "UserName",
          sortable: true,
          thStyle: "width: 35%;"
        },
        {
          key: "FirstName",
          label: "First",
          sortable: true
        },
        { key: "LastName", label: "Last", sortable: true },
        { key: "MemberOf.UserGroupName", label: "Group", sortable: true },
        { key: "Points", label: "Points", sortable: true },
        { key: "QuickAdd", label: "", sortable: false }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      bulkAddPoints: 0
    };
  },
  props: {},
  components: {
    cTable
    //StyledDialog
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.n_user.n_users.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["n_user", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    // rowClass(item, type) {
    //   if (!item || type !== "row") return;
    //   if (item.ReorderLevel > item.QuantityInStock) return "table-danger";
    // },
    async bulkAdd() {
      //console.log(this.$refs.BulkAddPoints);
      //console.log(this.$refs.BulkAddPoints._data.localValue);
      this.filteredObjects.forEach(_u => {
        var _obj = {
          UserProfileID: _u.UserProfileID,
          Quantity: this.bulkAddPoints,
          EnteredBy: this.$store.state.n_user.n_current_user.UserProfileID
        };
        this.$store.dispatch("n_user/AddTransaction", _obj);
      });
      await this.$store.dispatch("n_user/fetchUsers");
      this.filterList();
      // var _obj = {
      //   UserProfileID: object.UserProfileID,
      //   Quantity: object.QuickAddPoints,
      //   EnteredBy: this.$store.state.n_user.n_current_user.UserProfileID
      // };
      // await this.$store.dispatch("n_user/AddTransaction", _obj);
      // await this.$store.dispatch("n_user/fetchUsers");
      // this.filterList();
    },
    async quickAdd(object) {
      var _obj = {
        UserProfileID: object.UserProfileID,
        Quantity: object.QuickAddPoints,
        EnteredBy: this.$store.state.n_user.n_current_user.UserProfileID
      };
      await this.$store.dispatch("n_user/AddTransaction", _obj);
      await this.$store.dispatch("n_user/fetchUsers");
      this.filterList();
    },
    async myLoadComponent() {
      if (!this.$store.state.n_user.n_users) {
        await this.$store.dispatch("n_user/fetchUserGroups");
        await this.$store.dispatch("n_user/fetchUsers");
      }
      this.filterList();
    },
    async myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      await this.$store
        .dispatch("n_user/loadUserEdit", record.UserProfileID)
        .then(() => {
          this.$router.push("/points/ledger");
        });
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.n_user.n_users.filter(
        user => user.MemberOf.UserGroupID !== 2
      );

      this.filteredObjects = this.filteredObjects.filter(
        user =>
          user.FirstName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1 ||
          user.LastName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          user.UserName.toLowerCase().indexOf(this.searchString.toLowerCase()) >
            -1 ||
          // user.Address1.toLowerCase().indexOf(this.searchString.toLowerCase()) >
          //   -1 ||
          // user.City.toLowerCase().indexOf(this.searchString.toLowerCase()) >
          //   -1 ||
          // user.State.toLowerCase().indexOf(this.searchString.toLowerCase()) >
          //   -1 ||
          // user.Zip.toLowerCase().indexOf(this.searchString.toLowerCase()) >
          //   -1 ||
          user.MemberOf.UserGroupName.toLowerCase().indexOf(
            this.searchString.toLowerCase()
          ) > -1
      );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
